const PREVIEW_HEIGHT_PX = 420;

export function RenderedEmailPreviewFrame({
  subject,
  bodyHtml,
  bodyText,
}: {
  subject?: string;
  bodyHtml?: string;
  bodyText: string;
}) {
  const html = bodyHtml?.trim();
  return (
    <div className='space-y-2'>
      <p className='text-xs font-medium uppercase tracking-wide text-muted-foreground'>Vista previa final</p>
      <div className='overflow-hidden rounded-xl border bg-background shadow-sm'>
        <div className='border-b px-4 py-2 text-sm'>
          <span className='text-muted-foreground'>Asunto · </span>
          {subject?.trim() || 'Sin asunto'}
        </div>
        {html ? (
          <iframe
            title='Vista previa del correo'
            sandbox=''
            srcDoc={html}
            className='w-full border-0 bg-white'
            style={{ height: PREVIEW_HEIGHT_PX }}
          />
        ) : (
          <div className='max-h-[420px] overflow-auto px-4 py-3 text-sm whitespace-pre-wrap'>{bodyText || ' '}</div>
        )}
      </div>
      <p className='text-xs text-muted-foreground'>
        Datos de ejemplo (Ada Lovelace) con el mismo armado que en el envío real.
      </p>
    </div>
  );
}
